//请自行添加语言资源
const invoice = {
  rebateAmount:'返利金额',
  billMonth:'年月',
  paymentAmount:'付款金额',
  salesAmount:'销售金额',
  endingBalance:'期末余额',
  beginningBalance:'期初余额',
  confirmStatus:'确认状态',
  priceDueDate:'开票日期',
  reference:'采购订单号码',
  currencyType:'货币类型',
  sapNo:'销售凭证',
  postDate:'凭证日期',
  orderAmount:'订单金额',
  goldenTaxDate:'金税日期',
  goldenTaxNumber:'VAT编号',
  billRange:'范围',
  financialVoucherNo:'财务凭证号',
  type:'Type',
  textData:'文本',
  customerNo: '客户编号',
  customerName: '客户名称',
  msg:{
  }
};
export default invoice



// WEBPACK FOOTER //
// ./src/page/finance/invoice/lang/invoice.zh.js